import axios from 'axios';

export default {
    getDowntimeSummary( date, stationId, stationShiftId, success, error) {
        axios.get(`getDowntimeSummary?date=${date}&stationId=${stationId}&stationShiftId=${stationShiftId}`)
            .then(r => success(r.data))
            .catch(e => {
                console.error("Error while calling getDowntimeSummary: ", e.response.data);
            })
    }
}
